import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';

Vue.use(Vuex);

const modulesFiles = require.context('./modules', true, /\.js$/);

const modules = modulesFiles.keys().reduce((moduleObj, modulePath) => {
  const moduleObjCopy = { ...moduleObj };
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);

  moduleObjCopy[moduleName] = value.default;
  return moduleObjCopy;
}, {});

const store = new Vuex.Store({
  modules,
  getters,
});

export default store;
